import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';
import {catchError, defaultIfEmpty, map, Observable, of, take, timeout} from 'rxjs';
import {buildPath} from '@utils/util-builder';

@Injectable({providedIn: 'root'})
export class ServerAccountRoleGuard {
    constructor(private readonly _http: HttpClient, private readonly _router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const denied = this._router.parseUrl('/404-not-found');
        const allowedRoles: unknown = route.data['allowedRoles'];
        // Read without publishing account state or consulting the browser user cache.
        return this._http.get<{rol?: unknown} | null>(buildPath(['data-core/Account/getAccount'])).pipe(
            take(1),
            timeout(5000),
            map((account): boolean | UrlTree => {
                if (account == null) return this._router.parseUrl('/sign-in');
                return typeof account.rol === 'number' && Array.isArray(allowedRoles)
                    && allowedRoles.includes(account.rol) ? true : denied;
            }),
            defaultIfEmpty(denied),
            catchError((error: unknown) => of(error instanceof HttpErrorResponse && error.status === 401
                ? this._router.parseUrl('/sign-in') : denied))
        );
    }
}
